import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function setBannerModel() {
  const fetchSetBannerListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/List",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchSetBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/Detail",
    method: "POST",
    payload: {
      Set_Banner_Id: null,
    },
  });

  const fetchAssignSetBannerListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/SetBannerList",
    method: "POST",
    payload: {
      Banner_Id: null,
      Page: null,
      Limit: null,
      Filters: [],
    },
  });

  const assignToSetBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/AssignToSetBanner",
    method: "POST",
    payload: {
      Banner_Id: null,
      Set_Banner_Id: null,
    },
  });

  const removeSetBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/Delete",
    method: "POST",
    payload: {
      Set_Banner_Id: null,
    },
  });

  const createSetBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/Create",
    method: "POST",
    payload: {
      Set_Name: null,
      Description: null,
      Valid_From: null,
      Valid_Through: null,
      Layout_Section: null,
      Carousel: null,
      Layout_Type: null,
      Status: null,
      Banner_Mapping: [],
    },
  });

  const editSetBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/Edit",
    method: "POST",
    payload: {
      Set_Banner_Id: null,
      Set_Name: null,
      Description: null,
      Valid_From: null,
      Valid_Through: null,
      Layout_Section: null,
      Carousel: null,
      Layout_Type: null,
      Status: null,
      Banner_Mapping: [],
    },
  });

  const assignToSetBannersModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/AssignToSetBanners",
    method: "POST",
    payload: {
      Banner_Id: null,
      Banner_Assign_To_Set_Banners: [],
    },
  });

  return {
    fetchSetBannerListModel,
    fetchSetBannerModel,
    fetchAssignSetBannerListModel,
    assignToSetBannerModel,
    assignToSetBannersModel,
    removeSetBannerModel,
    createSetBannerModel,
    editSetBannerModel,
  };
}

export function groupBannerModel() {
  const fetchAssignGroupBannerListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/GroupBannerList",
    method: "POST",
    payload: {
      Banner_Id: null,
      Page: null,
      Limit: null,
      Filters: [],
    },
  });

  const assignToGroupBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/AssignToGroupBanner",
    method: "POST",
    payload: {
      Banner_Id: null,
      Group_Banner_Id: null,
    },
  });

  const fetchAssignSetToGroupBannerListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/GroupBannerList",
    method: "POST",
    payload: {
      Set_Banner_Id: null,
      Page: null,
      Limit: null,
      Filters: [],
    },
  });

  const assignSetToGroupBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/SetBanner/AssignToGroupBanner",
    method: "POST",
    payload: {
      Set_Banner_Id: null,
      Group_Banner_Id: null,
    },
  });

  const fetchGroupBannerListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/GroupBanner/List",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const createGroupBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/GroupBanner/Create",
    method: "POST",
    payload: {
      Group_Name: null,
      Description: null,
      Valid_From: null,
      Valid_Through: null,
      Status: null,
      isDefault: null,
      Banner_Mapping: [],
      Banner_Mapping_Other_Set: [],
    },
  });

  const editGroupBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/GroupBanner/Edit",
    method: "POST",
    payload: {
      Group_Banner_Id: null,
      Group_Name: null,
      Description: null,
      Valid_From: null,
      Valid_Through: null,
      Status: null,
      isDefault: null,
      Banner_Mapping: [],
      Banner_Mapping_Other_Set: [],
    },
  });

  const deleteGroupBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/GroupBanner/Delete",
    method: "POST",
    payload: {
      Group_Banner_Id: null,
    },
  });

  const fetchGroupBannerDetailModel = reactive({
    api: apiEndpoint.bcrm_platform + "/GroupBanner/Detail",
    method: "POST",
    payload: {
      Group_Banner_Id: null,
    },
  });

  return {
    fetchGroupBannerListModel,
    fetchAssignGroupBannerListModel,
    fetchAssignSetToGroupBannerListModel,
    fetchGroupBannerDetailModel,
    assignToGroupBannerModel,
    assignSetToGroupBannerModel,
    createGroupBannerModel,
    editGroupBannerModel,
    deleteGroupBannerModel,
  };
}

export function bannerModel() {
  const fetchRequestBannerKeyModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/RequestBannerKey",
    method: "POST",
    payload: {},
  });

  const fetchBannerFieldModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/FetchBannerField",
    method: "POST",
    payload: {},
  });

  const createBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/Create",
    method: "POST",
    payload: {
      TableName: "Banner_Banner",
      Banner_Image_Image_Url: null,
      Name: null,
      Call_To_Action: null,
      Status: null,
      Description: null,
      Note: null,
      Valid_From: null,
      Valid_Through: null,
      Seq: 1,
    },
  });

  const fetchBannerDetailModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/Detail",
    method: "POST",
    payload: { Banner_Id: null },
  });

  const deleteBannerModel = reactive({
    api: apiEndpoint.bcrm_platform + "/Banner/DeleteBanner",
    method: "POST",
    payload: { Banner_Id: null },
  });

  return {
    fetchRequestBannerKeyModel,
    fetchBannerFieldModel,
    fetchBannerDetailModel,
    createBannerModel,
    deleteBannerModel,
  };
}

export function bannerCriteria() {
  const fetchBannerCriteriaList = reactive({
    api: apiEndpoint.bcrm_platform + "/BannerCriteria/List",
    method: "POST",
    payload: {
      BannerId: 10,
      Page: 1,
      Limit: 5,
      Filters: [{ Seq: 1, Key: "status", Value: "false" }],
      Ordering: [],
    },
  });

  const createBannerCriteria = reactive({
    api: apiEndpoint.bcrm_platform + "/BannerCriteria/Create",
    method: "POST",
    payload: {
      BannerId: 6,
      Name: "Test",
      Priority: 7,
      Note: "Test",
      Req_IdentityId: 1,
      TagList: [
        {
          Seq: 1,
          Tag: "free112",
          Condition: "AND",
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 2,
          Tag: "tag011",
          Condition: "OR",
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 3,
          Tag: "tag021",
          Condition: "OR",
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 4,
          Tag: "festival1",
          Condition: "OR",
          GroupLv: 1,
          GroupNum: 1,
        },
      ],
    },
  });

  const editBannerCriteria = reactive({
    api: apiEndpoint.bcrm_platform + "/BannerCriteria/Edit",
    method: "POST",
    payload: {
      BannerId: 6,
      Criteria_GroupId: 9,
      Name: "เทสชื่อ",
      Priority: 40,
      Note: "เทสชื่อ",
    },
  });

  const removeBannerCriteria = reactive({
    api: apiEndpoint.bcrm_platform + "/BannerCriteria/Remove",
    method: "POST",
    payload: {
      Criteria_GroupId: 19,
    },
  });

  const fetchBannerCriteriaDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/BannerCriteria/Detail",
    method: "POST",
    payload: {
      BannerId: 10,
      Criteria_Group_Id: 18,
    },
  });

  return {
    fetchBannerCriteriaList,
    createBannerCriteria,
    editBannerCriteria,
    removeBannerCriteria,
    fetchBannerCriteriaDetail,
  };
}
